import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Currency } from 'client/voladeum/currencies/types';
import { SLICE } from 'ducks/slice';

import { EMPTY_ARRAY } from '../../constants';

const initialState: Currency[] = EMPTY_ARRAY;

export const currenciesSlice = createSlice({
  name: SLICE.CURRENCIES,
  initialState,
  reducers: {
    setCurrencies: (_state, action: PayloadAction<Currency[]>) => {
      return action.payload;
    },
    clearCurrencies: () => {
      return initialState;
    },
  },
});

export const { setCurrencies, clearCurrencies } = currenciesSlice.actions;

export default currenciesSlice.reducer;
